import React from 'react';
import { cn } from '@/lib/utils';

interface PageScrollIndicatorProps {
    currentPage: number;
    totalPages: number;
    isVisible: boolean;
    rightSidebarWidth: number;
}

export const PageScrollIndicator: React.FC<PageScrollIndicatorProps> = ({
    currentPage,
    totalPages,
    isVisible,
    rightSidebarWidth,
}) => {
    return (
        <div
            className={cn(
                'pointer-events-none fixed top-1/2 z-50 -translate-y-1/2 transition-all duration-300 ease-in-out',
                isVisible ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0',
            )}
            style={{ right: `${rightSidebarWidth + 28}px` }}
        >
            <div className="rounded-full border border-border bg-foreground/85 px-3 py-1.5 text-sm font-medium text-background shadow-xl backdrop-blur-sm">
                {currentPage} de {totalPages}
            </div>
        </div>
    );
};
